import { isApiError } from "~/utils/apiClient";
import { StatusMessage } from "./StatusMessage";
import { resourceIcon } from "./resourceIcon";

export interface ListLoadErrorProps {
  // The SWR/apiClient error (an `ApiError` carries `.status`). May be absent
  // when a fetch resolved without data, which we treat as a generic failure.
  error: unknown;
  // Plural, lowercase noun for the list, e.g. "projects", "agents".
  resourceLabel: string;
  className?: string;
}

/**
 * Maps a list-endpoint load failure to status-aware copy. A 403 here means the
 * account lacks AI access (the `USE_AGENTS` permission) rather than a
 * per-resource sharing gap, so it reads as an account-level message instead of
 * being conflated with a legitimately empty list.
 */
export const ListLoadError = ({ error, resourceLabel, className }: ListLoadErrorProps) => {
  const status = isApiError(error) ? error.status : undefined;
  const icon = resourceIcon(resourceLabel);

  if (status === 403) {
    return (
      <StatusMessage
        title="AI features aren't enabled for your account"
        body="Contact your administrator to request access."
        icon={icon}
        className={className}
      />
    );
  }

  return (
    <StatusMessage
      title={`Couldn't load ${resourceLabel}`}
      body="Something went wrong. Try again in a moment."
      icon={icon}
      className={className}
    />
  );
};
